export default __webpack_public_path__ + "static/media/email.2b324a5a.svg";